import { AnimatePresence, motion } from 'framer-motion';
import { ChevronLeft, ChevronRight, Quote } from 'lucide-react';
import React, { useState } from 'react';

const testimonials = [
  {
    name: 'Harsh',
    text: "I avoided the stock market because I didn't trust the advice out there. WealthDost feels different — more transparent and expert-driven."
  },
  {
    name: 'Vanshika',
    text: "Feels like learning finance from a friend."
  },
  {
    name: 'Kunal',
    text: "Finally, a place where I can understand money without confusion."
  },
  {
    name: 'Sahil',
    text: "Being a salaried employee, I was always looking for simple financial guidance glad WealthDost is building this."
  },
  {
    name: 'Suraj',
    text: "I was scared of finance… but WealthDost is helping me change that, step by step with its mission to bring trust and real experts into finance."
  }
];

const AppGallery = () => {
  const [current, setCurrent] = useState(0);

  const prev = () => setCurrent(i => (i - 1 + testimonials.length) % testimonials.length);
  const next = () => setCurrent(i => (i + 1) % testimonials.length);

  return (
    <section className="py-20 md:py-32 relative overflow-hidden" data-testid="app-gallery-section">
      <div className="max-w-7xl mx-auto px-6 mb-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#F8FAFC] mb-4">
            Designed for{' '}
            <span className="gradient-text">Trust-Led Investing</span>
          </h2>
          <p className="text-[#94A3B8] text-base md:text-lg max-w-2xl mx-auto">
            What our community is saying
          </p>
        </motion.div>
      </div>

      <div className="max-w-3xl mx-auto px-6">
        <div className="relative flex items-center gap-4">
          <button
            onClick={prev}
            className="flex-shrink-0 w-10 h-10 rounded-full border border-[#1E293B] bg-[#0F172A] flex items-center justify-center text-[#94A3B8] hover:text-[#F8FAFC] hover:border-[#2563EB] transition-colors"
            aria-label="Previous testimonial"
          >
            <ChevronLeft size={20} />
          </button>

          <div className="flex-1 overflow-hidden">
            <AnimatePresence mode="wait">
              <motion.div
                key={current}
                initial={{ opacity: 0, x: 40 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -40 }}
                transition={{ duration: 0.35 }}
                className="bg-[#0F172A] border border-[#1E293B] rounded-2xl p-8"
              >
                <Quote size={28} className="text-[#2563EB] mb-4" />
                <p className="text-[#CBD5E1] text-lg leading-relaxed mb-6">
                  {testimonials[current].text}
                </p>
                <p className="text-[#F8FAFC] font-semibold">
                  {testimonials[current].name}
                </p>
              </motion.div>
            </AnimatePresence>
          </div>

          <button
            onClick={next}
            className="flex-shrink-0 w-10 h-10 rounded-full border border-[#1E293B] bg-[#0F172A] flex items-center justify-center text-[#94A3B8] hover:text-[#F8FAFC] hover:border-[#2563EB] transition-colors"
            aria-label="Next testimonial"
          >
            <ChevronRight size={20} />
          </button>
        </div>

        {/* Dots */}
        <div className="flex justify-center gap-2 mt-6">
          {testimonials.map((_, i) => (
            <button
              key={i}
              onClick={() => setCurrent(i)}
              className={`w-2 h-2 rounded-full transition-all ${i === current ? 'bg-[#2563EB] w-5' : 'bg-[#1E293B]'}`}
              aria-label={`Go to testimonial ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default AppGallery;
